<template lang="pug">
    .info-banner
        span.text-banner-info(v-if="!isRecalculationRunning") {{ text }}
        span.text-banner-info(v-if="isRecalculationRunning") {{ confirmText }}
        button.reactivate-button(v-if="!isRecalculationRunning" @click.stop="recalculateStore") Recalculate Data
</template>

<script>

export default {
    props: {
        text: String,
    },
    data() {
        return {
            isOpen: false,
            loadingReactivate: false,
            confirmText: "Recalculation in progress..."

        };
    },
    computed: {
        isRecalculationRunning() {
            return this.$store.state.userdata.currentlyLoading
                || this.$store.state.userdata.recalculationJobRunning
                || this.loadingReactivate;
        }
    },
    methods: {
        recalculateStore() {
            console.log("Recalculating store...");
            this.loadingReactivate = true;
            this.$store.dispatch("userdata/recalculateTwoMonth")
                .finally(() => {
                    this.loadingReactivate = false;
                });

        }
    }
};
</script>

<style lang="scss" scoped>
.info-banner {
    display: flex;
    align-items: center;
    background-color: $text-color;
    color: white;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
}

.info-banner:hover {
    cursor: pointer;
    /* Add any other visual feedback for hover state */
}

.icon {
    margin-right: 15px;
    /* If additional alignment is needed, consider adjusting line-height or font-size */
}

.text-banner-info {
    font-weight: $normal-Font-Weight;
    font-size: $medium-Font-Size;
}

.reactivate-button {
    background-color: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.9rem;
    margin-left: 15px; /* Added spacing between the button and the text */
}
</style>
